import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import api from '../../../helpers/api';
import {isSystemAdmin, isRegionUser, isBusinessUnitUser, isCustomerUser, isLocationCustomer, groupBy} from '../../../helpers/utils';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifyError} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import {SystemAdminDashboard, CustomerUserDashboard, LocationCustomerDashboard, UserDashboard} from './subComponents';
import dashboard from '../locales/dashboard.json';

class DashboardBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			workOrderStat: {
				total: 0,
				new: 0,
				approved: 0,
				not_approved: 0,
				alert: 0
			},
			regionStat: {},
			businessUnitStat: {},
			customerStat: {},
			workOrdersNeedApproval: [],
			customerDashboard: {
				totalOpenWorkOrders: 0,
				workOrders: [],
				inspections: {},
				inspectionsLast3days: {},
				inspectionsLast7days: {},
				partInspections: {},
				partInspectionsLast3days: {},
				partInspectionsLast7days: {},
				workOrdersNeedApproval: [],
				invoiceStatistics: {
					dueInvoiceTheWeekCount: 0,
					pastDueInvoiceCount: 0
				}
			},
			locationCustomerDashboard: {
				totalOpenWorkOrders: 0,
				workOrders: [],
				inspections: {},
				inspectionsLast3days: {},
				inspectionsLast7days: {},
				partInspections: {},
				partInspectionsLast3days: {},
				partInspectionsLast7days: {}
			}
		}
	}

	componentDidMount() {
		const {loadLanguage} = this.props;
		loadLanguage(dashboard);
		this.loadDashboard();
	}

	loadDashboard = async () => {
		const {notifyError, session} = this.props;
		const permissionNames = session.permission_names;

		const canViewInvoice = permissionNames && permissionNames.includes('view_invoice');

		try {
			const response = await api.get(`/dashboard`);
			if (isSystemAdmin(session)) {
				const workOrderStat = response.data.work_order_stat;
				const regionStat = response.data.region_stat;

				this.setState({ workOrderStat: workOrderStat, regionStat: regionStat});
			} else if(isCustomerUser(session)) {
				const totalOpenWorkOrders = response.data.total_open_work_orders;
				const workOrders = response.data.work_orders;
				const inspections = response.data.inspections;
				const inspectionsLast3days = response.data.inspections_last_3_days;
				const inspectionsLast7days = response.data.inspections_last_7_days;
				const partInspections = response.data.part_inspections;
				const partInspectionsLast3days = response.data.part_inspections_last_3_days;
				const partInspectionsLast7days = response.data.part_inspections_last_7_days;
				const workOrdersNeedApproval = response.data.work_orders_need_approval;

				let invoiceStatistics = {
					dueInvoiceTheWeekCount: 0,
					pastDueInvoiceCount: 0
				}
				if (canViewInvoice) {
					const invoiceStatisticsResponse = await api.get('/invoices/statistics', {params: {past_due_invoices: true}});
					const {
						due_invoice_the_week_count: dueInvoiceTheWeekCount,
						past_due_invoice_count: pastDueInvoiceCount
					} = invoiceStatisticsResponse.data;

					invoiceStatistics.dueInvoiceTheWeekCount = dueInvoiceTheWeekCount;
					invoiceStatistics.pastDueInvoiceCount = pastDueInvoiceCount;
				}

				this.setState({
					customerDashboard: {
						...this.state.customerDashboard,
						totalOpenWorkOrders: totalOpenWorkOrders,
						workOrders: workOrders,
						inspections: groupBy(inspections, 'work_order_id'),
						inspectionsLast3days: groupBy(inspectionsLast3days, 'work_order_id'),
						inspectionsLast7days: groupBy(inspectionsLast7days, 'work_order_id'),
						partInspections: groupBy(partInspections, 'work_order_id', 'part_id'),
						partInspectionsLast3days: groupBy(partInspectionsLast3days, 'work_order_id', 'part_id'),
						partInspectionsLast7days: groupBy(partInspectionsLast7days, 'work_order_id', 'part_id'),
						workOrdersNeedApproval: workOrdersNeedApproval,
						invoiceStatistics
					}
				});
			} else if(isLocationCustomer(session)) {
				const totalOpenWorkOrders = response.data.total_open_work_orders;
				const workOrders = response.data.work_orders;
				const inspections = response.data.inspections;
				const inspectionsLast3days = response.data.inspections_last_3_days;
				const inspectionsLast7days = response.data.inspections_last_7_days;
				const partInspections = response.data.part_inspections;
				const partInspectionsLast3days = response.data.part_inspections_last_3_days;
				const partInspectionsLast7days = response.data.part_inspections_last_7_days;

				this.setState({
					locationCustomerDashboard: {
						...this.state.locationCustomerDashboard,
						totalOpenWorkOrders: totalOpenWorkOrders,
						workOrders: workOrders,
						inspections: groupBy(inspections, 'work_order_id'),
						inspectionsLast3days: groupBy(inspectionsLast3days, 'work_order_id'),
						inspectionsLast7days: groupBy(inspectionsLast7days, 'work_order_id'),
						partInspections: groupBy(partInspections, 'work_order_id', 'part_id'),
						partInspectionsLast3days: groupBy(partInspectionsLast3days, 'work_order_id', 'part_id'),
						partInspectionsLast7days: groupBy(partInspectionsLast7days, 'work_order_id', 'part_id')
					}
				});
			} else {
				const workOrderStat = response.data.work_order_stat;
				const businessUnitStat = response.data.business_unit_stat;
				const workOrdersNeedApproval = response.data.work_orders_need_approval;

				this.setState({ workOrderStat: workOrderStat, businessUnitStat: businessUnitStat, workOrdersNeedApproval: workOrdersNeedApproval});
			}
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate, session} = this.props;
		const permissionNames = session.permission_names;

		const content = (
			<div className="content-wrapper">
				{/*<section className="content-header">*/}
					{/*<h1>*/}
						{/*{translate('dashboard_page_title')}*/}
						{/*<small>{translate('dashboard_page_sub_title')}</small>*/}
					{/*</h1>*/}
				{/*</section>*/}

				<section className="content">
					{
						(isSystemAdmin(session)) && (
							<SystemAdminDashboard state={this.state} translate={translate}/>
						)
					}
					{
						(isCustomerUser(session)) && (
							<CustomerUserDashboard state={this.state.customerDashboard} permissionNames={permissionNames} translate={translate}/>
						)
					}
					{
						(isLocationCustomer(session)) &&
							<LocationCustomerDashboard state={this.state.locationCustomerDashboard} permissionNames={permissionNames} translate={translate}/>
					}
					{
						(isRegionUser(session)) && (
							<UserDashboard state={this.state} translate={translate}/>
						)
					}
					{
						(isBusinessUnitUser(session) && !isLocationCustomer(session)) && (
							<UserDashboard state={this.state} translate={translate}/>
						)
					}
				</section>
			</div>
		);

		return translate('dashboard_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale),
	session: state.session,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DashboardBox);
